import React, { useState ,useContext} from 'react'
import {AppFormItemProps,AppFormContext} from '../AppForm/index'
import {AppRadio,AppRadioProps} from '../AppRadio'


export const AppFormItemRadio = (props:AppFormItemProps) =>{
    
    const {onChange,formData} = useContext(AppFormContext);
    const radioProps = {...props,value:getRadioValue(props,formData)} as AppRadioProps;

    const handleChange = (value?:string,text?:string) =>{
        let itemProps = {...props,value} as AppFormItemProps ;
        onChange && onChange(itemProps);
    }

    return <AppRadio {...radioProps} onChange={handleChange}  />
}

const getRadioValue = (props:AppFormItemProps,formData?:any) =>{
    if(props.dataType === 'boolean'){
        return formData[props.keyName]? '1':'0';
    }
    return `${formData[props.keyName]}`
}



// WEBPACK FOOTER //
// ./src/qcc/AppFormItem/AppFormItemRadio.tsx